export default "__VITE_ASSET__DVlYHfcL__"